import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el:                   false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'artists-hover';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
        this.$win  = $(window);
        this.initHover(true);
	}

    initHover(b){
        if ( b ){

            this.images = [];
            this.$spans = this.$el.find( '#background .span' );
            this.$spans.each( (i, el)=>{
                this.images[i] = {
                    span: $(el),
                    $wrapper: $(el).find( '.img-wrapper' ),
                    archived: $(el).hasClass( 'archived' )
                }

                // force loading!!!
                lazySizes.loader.unveil( $(el).find( 'img' )[0] );
            });

            this.onResize();


            if ( this.$win.width() <= 480 || this.$html.hasClass( 'touch' ) ){
                this.$spans.removeClass( 'visible' );
            }

            //setTimeout( ()=>this.delayInit(), 100 );
            this.delayInit()

        }
        else{
            // do something???
        }

        this.addEvents( b );       
    }

    delayInit(){
        this.$el.addClass( 'ready' );
    }

    addEvents(b){

        let $li = this.$el.find( 'ul.trigger li' ), $first;

        if ( b ){
            $li.on( 'mouseover', ( e )=>{
                this.onMouseOver( $(e.currentTarget).attr( 'data-index' ), true, e  );
            });
            $li.on( 'mouseleave', ( e )=>{
                this.onMouseOver( $(e.currentTarget).attr( 'data-index' ), false, e  );
            });

            // center first before reveal
            $first = this.$el.find( 'ul.artists li:eq(0)' );
            $first.trigger( 'mouseover' );
        }
        else{
           $li.off( 'mouseover', ( e )=>{
                this.onMouseOver( $(e.currentTarget).attr( 'data-index' ), true, e  );
            });
            $li.off( 'mouseleave', ( e )=>{
                this.onMouseOver( $(e.currentTarget).attr( 'data-index' ), false, e  );
            });
        }

        this.debounceResize(b);
   
    }

    onMouseOver(i, b, e){
        let $span = this.images[i].span;

        if ( this.$html.hasClass( 'no-touch' ) && this.$win.width() > 480 ){
            if ( b ){
                this.$spans.removeClass( 'visible' );
                this.CenterVertically( $span, e );
                $span.addClass( 'visible' );
            }
            else{
                $span.removeClass( 'visible' );
            }            
        }
    }

    CenterVertically( $span, e ){
        let $container = this.$el.find( '#background' ), 
            y, 
            h = $span.height(), 
            //hh = $container.height(),//$('#main').height(),
            $li = $(e.currentTarget),
            isArchived = $li.parents( 'ul' ).hasClass( 'archived-artists' ),
            top = this.getLimit( 'top', isArchived ),
            bottom = this.getLimit( 'bottom', isArchived );

        

        /*

        y = $li.offset().top + parseInt($li.css('line-height'))/2 - $container.offset().top - h/2;

        */




    
        y = top + (bottom-top)/2 - h/2; 


        //console.log( y + ',' + h );

        // check boundaries

        /*
        if ( y < top ){
            y = top;
        }
        if ( y + h > bottom ){
            y = bottom - h;
        }
        */


        gsap.set( $span, {top:y} );
    }

    //---------------------------------------- COMMONS -----------------------------------------//
    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 137 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    // where the magic happen
    onResize(){

        this.setLimits();

        let h       = this.getLimit( 'bottom', false )  - this.getLimit( 'top', false ),
            ah      = this.getLimit( 'bottom', true )   - this.getLimit( 'top', true ),
            i       = this.images.length,
            img, $img_wrapper, orw, orh;

        while( i-- ){
            img = this.images[i];
            $img_wrapper = img.$wrapper;
            orw  = parseInt( $img_wrapper.attr( 'data-width' ) );
            orh  = orw; //parseInt( $img_wrapper.attr( 'data-height' ) );

            img.span.css({
                width:  Math.min( this.getMaxWidth(img.archived?ah:h), Math.round( orw/orh*(img.archived?ah:h) ) )
            })
        }


        /*
        let $img_wrapper, orw, orh, fixh, $layout;
        this.$el.find( '.slide-wrap' ).each( (i,el) => {

            $img_wrapper = $(el).find( '.img-wrapper' );
            orw  = parseInt( $img_wrapper.attr( 'data-width' ) );
            orh  = parseInt( $img_wrapper.attr( 'data-height' ) );

            $layout = $img_wrapper.parents( '.layout' );
            fixh = $layout.height();

            $img_wrapper.css({
                'height': fixh,
                'padding-bottom': '0%',
                'width': Math.round( orw/orh*fixh )
            }).removeClass( 'autosize' );

        });
        */

        //this.centerImages();
    }

    getMaxWidth( h ){
        return h*2/3;
    }

    setLimits(){
        let $container  = this.$el.find( '#background' ),
            $noTop      = $container.find( '.no-archived.top' ),
            $noBottom   = $container.find( '.no-archived.bottom' ),
            $aTop       = $container.find( '.archived.top' ),
            $aBottom    = $container.find( '.archived.bottom' ),

            margen      = 30;

        // no-archived bottom
        gsap.set( $noTop, {top: 2*margen } );

        // no-archived bottom
        gsap.set( $noBottom, {top: $('section.artists').offset().top - $container.offset().top + $('section.artists').height() + parseInt( $('section.artists').css( 'margin-bottom' ) ) - margen } );

        // archived top
        gsap.set( $aTop, {top: $('section.archived-artists').offset().top - $container.offset().top + 2*margen } );

        // archived bottom
        // gsap.set( $aBottom, {top: $('section.archived-artists').offset().top - $container.offset().top + $('section.archived-artists').height() + parseInt( $('section.archived-artists').css( 'margin-bottom' ) ) } );
        gsap.set( $aBottom, {top: $('#main').height() } );

    }

    getLimit( which, archived ){

        let $container  = this.$el.find( '#background' ),
            _class      = archived ? '.archived' : '.no-archived',
            $limit      = $container.find( _class + '.' + which ),
            y           = parseInt( $limit.css('top') );
            /*
            $noTop      = $container.find( '.no-archived.top' ),
            $noBottom   = $container.find( '.no-archived.bottom' ),
            $aTop       = $container.find( '.archived.top' ),
            $aBottom    = $container.find( '.archived.bottom' ),
            */

        return y;
    }

    // where the magic happen
    centerImages(){
        /*
        let $s =  this.$el.find( '.slick-slider' ), n = $s.find( '.slick-slide' ).length, dx, w, margin;
        if ( $s.hasClass( 'slick-initialized' ) ){
            if ( n > 1 && n <=3 ){
                w = 0;
                $s.find( '.slick-slide' ).each( (i,el)=>{
                    if ( i === 0 ){
                        // as it's centered, we calculate the width of the first slides and the margins between slides!
                        margin = $(el).width()/2 + parseInt( $(el).find( '.layout' ).css('margin-left') )*2*(n-1);
                    }
                    w += $(el).width();
                })
                //console.log( w + ' , ' + $s.width() + ' , ' + margin )
                if ( w < $s.width() ){
                    // center the slides
                    dx = - (w - margin)/2;
                }
                else{
                    // reset
                    dx = 0;
                }
                gsap.set( $s.find( '.slick-slide' ), {x:dx} );
            }
        }
        */
    }

    destroy(){
		if ( this.$el.length > 0){
            this.initHover( false );
    	}
    }

}


